export const Xml80020 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M19.0061 7.74753V19.29C19.0061 19.9345 18.7501 20.5526 18.2944 21.0083C17.8386 21.464 17.2206 21.72 16.5761 21.72V20.505C16.8983 20.505 17.2074 20.377 17.4352 20.1492C17.6631 19.9213 17.7911 19.6123 17.7911 19.29V7.74753H15.3611C14.8777 7.74753 14.4142 7.55552 14.0724 7.21373C13.7306 6.87195 13.5386 6.40839 13.5386 5.92503V3.49503H6.85609C6.53386 3.49503 6.22482 3.62304 5.99696 3.85089C5.7691 4.07875 5.64109 4.38779 5.64109 4.71003V15.645H4.42609V4.71003C4.42609 4.06555 4.68211 3.44747 5.13782 2.99176C5.59354 2.53605 6.21162 2.28003 6.85609 2.28003H13.5386L19.0061 7.74753ZM6.2814 16.6778H5.1964L4.19646 18.4262H4.15272L3.14184 16.6778H2.01067L3.50148 19.0871L1.99609 21.5378H3.04221L4.0786 19.8186H4.12113L5.15388 21.5378H6.2571L4.73349 19.1175L6.2814 16.6778ZM7.44051 21.5366V18.3047H7.48668L8.64336 20.9278H9.2703L10.4197 18.3034H10.4659V21.5366H11.3346V16.6778H10.3626L8.97748 19.8319H8.94711L7.56079 16.6778H6.5815V21.5366H7.44051ZM13.1632 20.7177H15.2238V21.5366H12.2021V16.6778H13.1632V20.7177Z"
      fill="#0AAAE6"
    />
  </svg>
);
